import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export const ModalBody = styled(Modal.Body)`
  padding: 50px 80px 0px;
`

export const ModalFooter = styled(Modal.Footer)`
  padding-bottom: 35px;
  display: flex;
  justify-content: center;
  border-top: 0;
`;

export const StyledImg = styled.img`
  width: 100%;
`;

export const ModalClose = styled(Button)`
  position: absolute;
  top: -14px;
  right: -12px;
  padding: 10px;
  background: #fff;
  border-radius: 100%;
  border-width: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: radial-gradient(100% 100% at 0% 0%, rgba(221, 227, 250, 0.99) 0%, rgba(221, 229, 250, 0.4) 100%);
  &:hover{
    box-shadow: none;
    border-radius: 100%;
    border-width: 0;
  }
  &:focus{
    border-width: 0;
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    border-radius: 100%;
  }
`

export const StyledModalBtn = styled(Button)`
  &.FeedbackFooter{
    font-family: Manrope, sans-serif;
    font-size: 14px;
    font-weight: 600;
    width: 162px;
    line-height: 50px;
    background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
    border-radius: 8px;
    border-width: 0;
    padding: 0;
  
    &:hover{
      background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
      box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
      border-radius: 8px;
      border-width: 0;
    }
    &:focus{
      border-width: 0;
      background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
      box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
      border-radius: 8px;
    }
  }
  &.HeaderBtn{
    position: absolute;
    top: -14px;
    right: -12px;
    padding: 10px;
    background: #fff;
    border-radius: 100%;
    border-width: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: radial-gradient(100% 100% at 0% 0%, rgba(221, 227, 250, 0.99) 0%, rgba(221, 229, 250, 0.4) 100%);
    &:hover{
      box-shadow: none;
      border-radius: 100%;
      border-width: 0;
    }
    &:focus{
      border-width: 0;
      box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
      border-radius: 100%;
    }
  }
`;

export const H3 = styled.h3`
  font-family: Manrope, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 30px;
`

export const Content = styled.div`
  font-family: OpenSans, sans-serif;
  font-weight: 400;
  font-size: 16px;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  &.strong{
    font-weight: 600;
  }
  & img {
    max-width: 40px;
    margin-left: 5px;
    margin-right: 2px;
  }
  & .token-status-container{
    padding-left: 15px;
    color: #3F1CEF;
    margin-top: 20px;
    font-size: 14px;
  }
  & .general-list{
    margin-top: 20px;
    & li{
      margin-top: 5px;
      line-height: 28px;
    }
  }
`

export const SigninBtn = styled(Button)`
  font-family: Roboto, sans-serif;
  font-weight: 600;
	background: #4285F4;
	border-radius: 2px;
	display: flex;
	//justify-content: space-between;
	align-items: center;
	padding: 2px;
	border-width: 0;
	&:hover{
    background: #4285F4;
		//background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
		box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
	}
	&:focus{
		//background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
		box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
		border-width: 0;
	}
	&:not(:disabled):not(.disabled):active:focus{
		//background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
		box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
		border-width: 0;
	}
  & .logoContainer{
    height: 36px;
    width: 36px;
    border-radius: 2px;
    background: #ffffff;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  & span{
    flex: 1;
    padding: 0 24px;
  }
`;